module.exports = __webpack_public_path__ + "static/media/scholastic-logo-updated.e70df838.svg";